<template>
  <v-card style="margin: 0;padding: 0;">
    <v-card-title primary-title style="margin: 0;padding:0 5px;">
      <v-subheader>基本属性</v-subheader>
    </v-card-title>
    <v-divider></v-divider>
    <v-container grid-list-md fluid>
      <v-layout row wrap>
        <v-flex xs12 sm6md4 lg3 xl2 v-for="item in basicProps" :key="item.value">
          <gh-input :model="model" :prop="item"></gh-input>
        </v-flex>
        <v-flex xs12 sm6md4 lg3 xl2 v-if="model.type==='string'">
          <v-autocomplete v-model="model.alertType" clearable label="提示"
            :items="['','success','info','warning','error ']">
          </v-autocomplete>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<style scoped>

</style>

<script>
  import BasicProperty from "./basicProperty.ts";
  export default BasicProperty;
</script>